module.exports = __webpack_public_path__ + "img/cover-slot-bg.56488be0.jpg";